import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { IsEnum, IsNotEmpty, IsNumber, IsString, Max, MaxLength, Min } from 'class-validator';
import { Column } from 'typeorm';
import { LengthWithLVS } from '../../validator';
import { GeoProviderEnum } from './GeoProviderEnum';
export class FullFilledGeoLocation {
}
__decorate([
    Column(),
    ApiProperty({ type: String, minLength: 5, example: '150 W 65th St, New York, NY 10023' }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(5, 150, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "formattedAddress", void 0);
__decorate([
    Column(),
    ApiProperty({ example: 40.773595 }),
    IsNotEmpty({ always: true }),
    IsNumber(undefined, { always: true }),
    Min(-90, { always: true }),
    Max(90, { always: true }),
    __metadata("design:type", Number)
], FullFilledGeoLocation.prototype, "latitude", void 0);
__decorate([
    Column(),
    ApiProperty({ example: -40.773595 }),
    IsNotEmpty({ always: true }),
    IsNumber(undefined, { always: true }),
    Min(-180, { always: true }),
    Max(180, { always: true }),
    __metadata("design:type", Number)
], FullFilledGeoLocation.prototype, "longitude", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String, example: 'United states' }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(2, 100, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "country", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String, example: 'US' }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(2, 2, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "countryCode", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String, example: 'California' }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(2, 100, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "state", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String, example: 'CA' }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(2, 2, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "stateCode", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(2, 50, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "city", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(3, 20, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "postalCode", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(255, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "streetName", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(50, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "houseNumber", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String }),
    IsNotEmpty({ always: true }),
    IsEnum(GeoProviderEnum, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "provider", void 0);
__decorate([
    Column(),
    ApiProperty({ type: String }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(255, { always: true }),
    __metadata("design:type", String)
], FullFilledGeoLocation.prototype, "placeId", void 0);
//# sourceMappingURL=FullFilledGeoLocation.js.map